<template>
  <div class="pb-1">
    <!-- customer address -->
    <b-card no-body>
      <b-card-header>
        <div class="d-flex align-items-center">
          <feather-icon icon="AlignJustifyIcon" size="24"/>
          <span class="h4 pt-1">ที่อยู่จัดส่งของฉัน</span>
        </div>
        <b-button class="float-right" variant="primary" size="sm" @click="openModal(true)">เพิ่มที่อยู่ใหม่</b-button>
      </b-card-header>
      <!-- pc -->
      <b-card-body class="d-none d-sm-block">
        <b-table
          :items="addressList"
          :fields="addressFields"
          responsive
          small
          bordered
        >
          <template #cell(isDefault)="data">
            <b-img v-if="data.value == true" :src="require('@/assets/Correct.png')"></b-img>
          </template>
          <template v-slot:head(phone)>
            <div></div>
          </template>
          <template #cell(phone)="data">
            <b-link v-if="data.item.isNotDefault == true" @click="isDefaultAddress(data.item)">ทำเป็นที่อยู่หลัก</b-link>
          </template>
          <template #cell(name)="data">
            คุณ {{data.item.name}} โทร: {{data.item.phone}} {{data.item.address}} {{data.item.tambon}} {{data.item.amphoe}} {{data.item.province}} {{data.item.postcode}}
          </template>
          <template #cell(address)="data">
            <div class="text-nowrap">
              <feather-icon
                :id="`invoice-row-${data.item.addressID}-edit-icon`"
                icon="EditIcon"
                size="20"
                class="cursor-pointer"
                @click="editAddress(data.item.addressID, true)"
              />
              <b-tooltip
                title="แก้ไข"
                :target="`invoice-row-${data.item.addressID}-edit-icon`"
                :delay="{show: '1500'}"
              />
              <feather-icon
                :id="`invoice-row-${data.item.addressID}-delete-icon`"
                icon="TrashIcon"
                class="cursor-pointer ml-1 text-danger"
                size="20"
                @click="deleteAddress(data.item, true)"
              />
              <b-tooltip
                title="ลบ"
                :target="`invoice-row-${data.item.addressID}-delete-icon`"
                :delay="{show: '1500'}"
              />
            </div>
          </template>
        </b-table>
      </b-card-body>
      <!-- mobile -->
      <hr class="dense d-block d-sm-none mx-1 mt-0">
      <b-card-body class="d-block d-sm-none py-0" v-for="item in addressList" :key="item.length">
        <div class="pb-1">คุณ {{item.name}} โทร: {{item.phone}} {{item.address}} {{item.tambon}} {{item.amphoe}} {{item.province}} {{item.postcode}}</div>
        <div>
          <b-row class="align-items-center">
            <b-col>
              <span v-if="item.isDefault == true" style="color:green"><b-img :src="require('@/assets/Correct.png')"/> ที่อยู่หลัก</span>
              <span v-else><b-link @click="isDefaultAddress(item)">ทำเป็นที่อยู่หลัก</b-link></span>
            </b-col>
            <b-col class="text-right">
              <b-button @click="editAddress(item.addressID, true)" class="btn-icon rounded-circle" variant="warning">
                <feather-icon class="icon" icon="Edit2Icon" size="15"/>
              </b-button>
              <b-button @click="deleteAddress(item, true)" class="btn-icon rounded-circle ml-2" variant="danger">
                <feather-icon class="icon" icon="Trash2Icon" size="15"/>
              </b-button>
            </b-col>
          </b-row>
        </div>
        <hr class="dense">
      </b-card-body>
    </b-card>

    <b-modal
      id="address"
      ref="address"
      @hidden="hideModal"
      title-class="h2"
      :title="this.editBtn == false ? 'เพิ่มที่อยู่ใหม่' : 'แก้ไขที่อยู่'"
      hide-footer
      content-class="shadow"
      no-close-on-backdrop
    >
      <b-form>
        <b-card-body class="py-0 px-0">
          <b-form>
          <b-row>
            <b-col cols="12">
              <b-form-group
                class="font-weight-slim"
                label="ชื่อ :"
              >
                <div class="d-flex align-items-center">
                  <b-form-input v-model="name"/>
                  <span v-if="this.valName == false" class="pl-2" style="color:red">กรุณาระบุ</span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                class="font-weight-slim"
                label="เบอร์โทร :"
              >
                <div class="d-flex align-items-center">
                  <b-form-input v-model="phone"/>
                  <span v-if="this.valPhone == false" class="pl-2" style="color:red">กรุณาระบุ</span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                class="font-weight-slim"
                label="ที่อยู่ :"
              >
                <div class="d-flex align-items-center">
                  <b-form-textarea v-model="address"/>
                  <span v-if="this.valAddress == false" class="pl-2" style="color:red">กรุณาระบุ</span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                class="font-weight-slim"
                label="รหัสไปรษณีย์/ตำบล/อำเภอ/จังหวัด :"
              >
                <div class="d-flex align-items-center">
                  <v-select
                    class="px-0 col-12"
                    v-model="postcode"
                    :options="postcodeMapping"
                    label="list"
                  ></v-select>
                  <span v-if="this.valPostcode == false" class="pl-2" style="color:red">กรุณาระบุ</span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="this.checkTypeAddress == true">
              <b-form-group
              >
                <div class="d-flex align-items-center">
                  <b-form-checkbox v-model="defaultAddress"></b-form-checkbox>
                  <span >ใช้เป็นที่อยู่จัดส่งหลัก</span>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          </b-form>
        </b-card-body>
        <div class="pt-1 float-right">
          <b-button
            v-if="this.editBtn == false"
            @click="btnAddAddress()"
            variant="primary"
            size="sm"
            :disabled="this.loadButton == false"
          >
            <b-spinner v-if="this.loadButton == false" small />
            เพิ่มที่อยู่ใหม่
          </b-button>
          <b-button
            v-if="this.editBtn == true"
            @click="btnEditAddress()"
            variant="primary"
            size="sm"
            :disabled="this.loadEditButton == false"
          >
            <b-spinner v-if="this.loadEditButton == false" small />
            แก้ไขที่อยู่
          </b-button>
          <b-button class="ml-1" @click="hideModal()" variant="outline-danger" size="sm">ยกเลิก</b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- sender address -->
    <b-card no-body>
      <b-card-header>
        <div class="d-flex align-items-center">
          <feather-icon icon="AlignJustifyIcon" size="24"/>
          <span class="h4 pt-1">ที่อยู่จัดส่งในนาม</span>
        </div>
        <b-button class="float-right" variant="primary" size="sm" @click="openModal(false)">เพิ่มที่อยู่ใหม่</b-button>
      </b-card-header>
      <!-- pc -->
      <b-card-body class="d-none d-sm-block">
        <b-table
          :items="senderAddressList"
          :fields="senderFields"
          responsive
          small
          bordered
        >
          <template #cell(name)="data">
            คุณ {{data.item.name}} โทร: {{data.item.phone}} {{data.item.address}} {{data.item.tambon}} {{data.item.amphoe}} {{data.item.province}} {{data.item.postcode}}
          </template>
          <template #cell(address)="data">
            <div class="text-nowrap">
              <feather-icon
                :id="`invoice-row-${data.item.addressID}-edit-icon`"
                icon="EditIcon"
                size="20"
                class="cursor-pointer"
                @click="editAddress(data.item.addressID, false)"
              />
              <b-tooltip
                title="แก้ไข"
                :target="`invoice-row-${data.item.addressID}-edit-icon`"
                :delay="{show: '1500'}"
              />
              <feather-icon
                :id="`invoice-row-${data.item.addressID}-delete-icon`"
                icon="TrashIcon"
                class="cursor-pointer ml-1 text-danger"
                size="20"
                @click="deleteAddress(data.item, false)"
              />
              <b-tooltip
                title="ลบ"
                :target="`invoice-row-${data.item.addressID}-delete-icon`"
                :delay="{show: '1500'}"
              />
            </div>
          </template>
        </b-table>
      </b-card-body>
      <!-- mobile -->
      <hr class="dense d-block d-sm-none mx-1 mt-0">
      <b-card-body class="d-block d-sm-none py-0" v-for="item in senderAddressList" :key="item.length">
        <div class="pb-1">คุณ {{item.name}} โทร: {{item.phone}} {{item.address}} {{item.tambon}} {{item.amphoe}} {{item.province}} {{item.postcode}}</div>
        <div>
          <b-row class="align-items-center">
            <b-col class="text-right">
              <b-button @click="editAddress(item.addressID, false)" class="btn-icon rounded-circle" variant="warning">
                <feather-icon class="icon" icon="Edit2Icon" size="15"/>
              </b-button>
              <b-button @click="deleteAddress(item, false)" class="btn-icon rounded-circle ml-2" variant="danger">
                <feather-icon class="icon" icon="Trash2Icon" size="15"/>
              </b-button>
            </b-col>
          </b-row>
        </div>
        <hr class="dense">
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BFormFile, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
  BInputGroupAppend, BButton, BCardBody, BCard, BTabs, BTab, BSpinner, BRow, BCol, BFormRadioGroup,
  BFormCheckbox, BFormTextarea, BLink, BCardHeader, BFormRadio, BCardFooter, BModal, VBModal, BForm,
  BImg, BTable, BTooltip
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";

export default {
  name: 'Taobao2youAddress',

    directives: {
    'b-modal': VBModal,
  },

  components: {
    BCard, BCardHeader, BCardBody, BCardFooter, BRow, BCol, BForm, BFormGroup, BButton, BFormInput,
    BFormTextarea, BFormCheckbox, BTable, BImg, BFormSelect, BPagination, BModal, ToastificationContent,
    vSelect, BLink, BSpinner, BTooltip,
   },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      name: '',
      phone: '',
      address: '',
      postcodeMapping: [],
      postcode: { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--'},
      defaultAddress: false,

      addressList: [],
      addressFields: [
        { key: 'isDefault', label: 'ที่อยู่หลัก', thClass: 'text-center', tdClass: 'text-center', thStyle: { width: "8%" } },
        { key: 'name', label: 'ที่อยู่' },
        { key: 'phone', thStyle: { width: "13%" }, tdClass: 'text-center' },
        { key: 'address', label: 'ตัวเลือก', thClass: 'text-center', tdClass: 'text-center', thStyle: { width: "8%" }},
      ],

      senderAddressList: [],
      senderFields: [
        { key: 'name', label: 'ที่อยู่' },
        { key: 'address', label: 'ตัวเลือก', thClass: 'text-center', tdClass: 'text-center', thStyle: { width: "8%" }},
      ],

      valName: true,
      valPhone: true,
      valAddress: true,
      valPostcode: true,

      editBtn: false,
      editAddressList: [],
      addressId: null,

      checkTypeAddress: null,

      loadButton: true,
      loadEditButton: true,
    };
  },

  created() {
    this.getPostcode()
    this.getCustomerAddress()
    this.getSenderAddress()
  },

  methods: {
    async getPostcode(){
      if (JSON.parse(localStorage.getItem('postcode'))) {
        this.postcodeMapping = JSON.parse(localStorage.getItem('postcode'))
      } else {
        let response = await axios.get(
          taobaoService_dotnet + 'app/Customer/get-postcode-mapping',
          { headers: header_token }
        );
        response.data.forEach((e) => {
          this.postcodeMapping .push(
            {
              'list': e.postcode + " / " + e.subDistrict + " / " + e.district + " / " + e.province,
              'provinceID': e.provinceID,
              'rowID': e.rowID,
              'subDistrict': e.subDistrict,
              'district': e.district,
              'province': e.province,
              'postcode': e.postcode,
            }
          )
        })
        localStorage.setItem('postcode', JSON.stringify(this.postcodeMapping ))
      }
    },
    async getCustomerAddress(){
      let response = await axios.post(
        taobaoService_dotnet + 'app/Customer/get-customer-address',
        {
          "loginToken": this.userData.data.customerInfo.loginToken,
          "isReceiver": true
        },
        { headers: header_token }
      );
      this.addressList = response.data
    },
    async getSenderAddress(){
      let response = await axios.post(
        taobaoService_dotnet + 'app/Customer/get-customer-address',
        {
          "loginToken": this.userData.data.customerInfo.loginToken,
          "isReceiver": false
        },
        { headers: header_token }
      );
      this.senderAddressList = response.data
    },
    async btnAddAddress() {
      this.loadButton = false
      if (this.name == '') {
        this.valName = false
      } if(this.phone == '') {
        this.valPhone = false
      } if(this.address == '') {
        this.valAddress = false
      } if(this.postcode == null || this.postcode.rowID == null) {
        this.valPostcode = false
      } else if( this.name != '' && this.phone != '' && this.address != '' && this.postcode.rowID != null) {
        if (this.checkTypeAddress == true) {
          let response = await axios.post(
            taobaoService_dotnet + 'app/Customer/add-customer-address',
            {
              'loginToken': this.userData.data.customerInfo.loginToken,
              'name': this.name,
              'phone': this.phone,
              'address': this.address,
              'tambon': this.postcode.subDistrict,
              'amphoe': this.postcode.district,
              'provinceID': this.postcode.provinceID,
              'province': this.postcode.province,
              'postcode': this.postcode.postcode,
              'postcodeMappingID': this.postcode.rowID,
              'isDefault': this.defaultAddress,
              'isReceiver': true
            },
            { headers: header_token }
          );
        } else if (this.checkTypeAddress == false) {
          let response = await axios.post(
            taobaoService_dotnet + 'app/Customer/add-sender-address',
            {
              'loginToken': this.userData.data.customerInfo.loginToken,
              'name': this.name,
              'phone': this.phone,
              'address': this.address,
              'tambon': this.postcode.subDistrict,
              'amphoe': this.postcode.district,
              'provinceID': this.postcode.provinceID,
              'province': this.postcode.province,
              'postcode': this.postcode.postcode,
              'postcodeMappingID': this.postcode.rowID,
              'isDefault': false,
              'isReceiver': false
            },
            { headers: header_token }
          );
        }
        this.name = ''
        this.phone = ''
        this.address = ''
        this.postcode = { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--'}
        this.defaultAddress = false
        this.valName = true
        this.valPhone = true
        this.valAddress = true
        this.valPostcode = true
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'สำเร็จ',
            icon: 'CheckIcon',
            text: 'บันทึกที่อยู่ใหม่เรียบร้อย',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        this.$refs['address'].hide()
        if (this.checkTypeAddress == true) this.getCustomerAddress()
        if (this.checkTypeAddress == false) this.getSenderAddress()
      }
      this.loadButton = true
    },
    async btnEditAddress() {
      this.loadEditButton = false
      if (this.name == '') {
        this.valName = false
      } if(this.phone == '') {
        this.valPhone = false
      } if(this.address == '') {
        this.valAddress = false
      } if(this.postcode == null || this.postcode.rowID == null) {
        this.valPostcode = false
      } else if( this.name != '' && this.phone != '' && this.address != '' && this.postcode.rowID != null) {
        if (this.checkTypeAddress == true) {
          let response = await axios.post(
            taobaoService_dotnet + 'app/Customer/update-customer-address',
            {
              'loginToken': this.userData.data.customerInfo.loginToken,
              'addressID': this.addressId,
              'name': this.name,
              'phone': this.phone,
              'address': this.address,
              'tambon': this.postcode.subDistrict,
              'amphoe': this.postcode.district,
              'provinceID': this.postcode.provinceID,
              'province': this.postcode.province,
              'postcode': this.postcode.postcode,
              'postcodeMappingID': this.postcode.rowID,
              'isDefault': this.defaultAddress
            },
            { headers: header_token }
          );
        } else if (this.checkTypeAddress == false) {
          let response = await axios.post(
            taobaoService_dotnet + 'app/Customer/update-sender-address',
            {
              'loginToken': this.userData.data.customerInfo.loginToken,
              'addressID': this.addressId,
              'name': this.name,
              'phone': this.phone,
              'address': this.address,
              'tambon': this.postcode.subDistrict,
              'amphoe': this.postcode.district,
              'provinceID': this.postcode.provinceID,
              'province': this.postcode.province,
              'postcode': this.postcode.postcode,
              'postcodeMappingID': this.postcode.rowID,
              'isDefault': false
            },
            { headers: header_token }
          );

        }
        this.name = ''
        this.phone = ''
        this.address = ''
        this.addressId = null
        this.postcode = { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--'}
        this.defaultAddress = false
        this.valName = true
        this.valPhone = true
        this.valAddress = true
        this.valPostcode = true
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'สำเร็จ',
            icon: 'CheckIcon',
            text: 'แก้ไขที่อยู่เรียบร้อย',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        this.editBtn = false
        this.$refs['address'].hide()
        if (this.checkTypeAddress == true) this.getCustomerAddress()
        if (this.checkTypeAddress == false) this.getSenderAddress()
        this.loadEditButton = true
      }
    },
    async deleteAddress(item, check) {
      this.$swal({
        title: 'ต้องการลบที่อยู่?',
        text: 'คุณ ' + item.name + 'โทร: ' + item.phone + ' ' + item.address + ' ' + item.tambon + ' ' + item.amphoe + ' ' + item.province + ' ' + item.postcode,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          if (check == true) {
            let response = await axios.post(
              taobaoService_dotnet + 'app/Customer/delete-customer-address',
              {
                'addressID': item.addressID,
                'loginToken': this.userData.data.customerInfo.loginToken,
              },
              { headers: header_token }
            );
            this.getCustomerAddress()
          } else if (check == false) {
            let response = await axios.post(
              taobaoService_dotnet + 'app/Customer/delete-sender-address',
              {
                'addressID': item.addressID,
                'loginToken': this.userData.data.customerInfo.loginToken,
              },
              { headers: header_token }
            );
            this.getSenderAddress()
          }
        }
      })
    },
    async editAddress(addressId, check) {
      this.checkTypeAddress = check
      this.editAddressList = await []
      var keepdata = []
      this.editBtn = true
      if (check == true) {
        keepdata = await this.addressList.filter(function(item) {
          return item.addressID == addressId
        });
      } else if (check == false) {
        keepdata = await this.senderAddressList.filter(function(item) {
          return item.addressID == addressId
        });
      }
      this.name = keepdata[0].name
      this.phone = keepdata[0].phone
      this.address = keepdata[0].address
      this.addressId = keepdata[0].addressID
      this.postcode = {
        'list': keepdata[0].postcode + " / " + keepdata[0].tambon + " / " + keepdata[0].amphoe + " / " + keepdata[0].province,
        'subDistrict': keepdata[0].tambon,
        'district': keepdata[0].amphoe,
        'province': keepdata[0].province,
        'postcode': keepdata[0].postcode,
        'provinceID': keepdata[0].provinceID,
        'rowID': keepdata[0].postcodeMappingID
      }
      this.defaultAddress = await keepdata[0].isDefault
      this.$refs['address'].show()
    },
    async isDefaultAddress(item) {
      this.$swal({
        title: 'ต้องการเปลี่ยนที่อยู่หลัก?',
        text: 'คุณ ' + item.name + 'โทร: ' + item.phone + ' ' + item.address + ' ' + item.tambon + ' ' + item.amphoe + ' ' + item.province + ' ' + item.postcode,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          let response = await axios.post(
            taobaoService_dotnet + 'app/Customer/update-customer-address',
            {
              'loginToken': this.userData.data.customerInfo.loginToken,
              'addressID': item.addressID,
              'name': item.name,
              'phone': item.phone,
              'address': item.address,
              'tambon': item.tambon,
              'amphoe': item.amphoe,
              'provinceID': item.provinceID,
              'province': item.province,
              'postcode': item.postcode,
              'postcodeMappingID': item.postcodeMappingID,
              'isDefault': true
            },
            { headers: header_token }
          );
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'เปลี่ยนที่อยู่หลักเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.getCustomerAddress()
        }
      })
    },
    async openModal(check) {
      this.checkTypeAddress = await check
      this.$refs['address'].show()
    },
    hideModal() {
      this.name = ''
      this.phone = ''
      this.address = ''
      this.addressId = null
      this.postcode = { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--'}
      this.defaultAddress = false
      this.valName = true
      this.valPhone = true
      this.valAddress = true
      this.valPostcode = true
      this.editBtn = false
      this.$refs['address'].hide()
    },
  },
};
</script>

<style lang="scss" scoped>

</style>